module.exports = __webpack_public_path__ + "img/page-bg.b8bbe3b3.png";